import { OnInit } from '@angular/core';
import { AnimationEvent } from '@angular/animations';
var AccordionElementBodyComponent = /** @class */ (function () {
    function AccordionElementBodyComponent() {
    }
    AccordionElementBodyComponent.prototype.ngOnInit = function () {
    };
    AccordionElementBodyComponent.prototype.onAnimationEvent = function (event) {
        this.overflowVisible = event.phaseName === 'done' && event.toState === 'open';
    };
    AccordionElementBodyComponent.prototype.setState = function (expanded) {
        this.expanded = expanded;
    };
    Object.defineProperty(AccordionElementBodyComponent.prototype, "overflow", {
        get: function () {
            return this.overflowVisible ? 'visible' : 'hidden';
        },
        enumerable: true,
        configurable: true
    });
    return AccordionElementBodyComponent;
}());
export { AccordionElementBodyComponent };
